import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import articles from '@/content/articles';

const RECENT_COUNT = 15;

export default function BlogList() {
  const recent = articles.slice(0, RECENT_COUNT);

  return (
    <div className="min-h-screen bg-white">
      <Navbar solid />

      <main className="pt-28 pb-20 px-6 md:px-10 max-w-3xl mx-auto">
        <h1
          className="text-2xl font-bold text-[#0F172A] mb-10"
          style={{ fontFamily: "'Noto Sans SC', sans-serif" }}
        >
          洞察
        </h1>

        <div className="flex flex-col divide-y divide-slate-100">
          {recent.map((a) => (
            <Link
              key={a.slug}
              to={`/blog/${a.slug}`}
              className="group py-6 first:pt-0 last:pb-0 cursor-pointer"
            >
              <p
                className="text-base font-medium text-[#0F172A] group-hover:text-[#F97316] transition-colors leading-relaxed"
                style={{ fontFamily: "'Noto Sans SC', sans-serif" }}
              >
                {a.title}
              </p>
              <p className="mt-1.5 text-sm text-[#94A3B8]">{a.date}</p>
            </Link>
          ))}
        </div>

        {articles.length > RECENT_COUNT && (
          <div className="mt-10 pt-8 border-t border-slate-100">
            <Link
              to="/blog/archive"
              className="text-sm text-[#94A3B8] hover:text-[#F97316] transition-colors"
            >
              查看全部归档（共 {articles.length} 篇） →
            </Link>
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
}
